<template>
  <div class='navs'>
    <div class="title"><i v-if="navData.icon" :class="navData.icon"></i>{{this.navData.name}}</div>
    <div class="menu">
      <div class="menuLi" v-for="item in menuList" :key="item.id" @click="userMenuItemClick(item.id)">
        <img :src="item.url" :alt="item.lable">
        <span v-if="!item.menu">{{item.lable}}</span>
        <el-dropdown v-else @command="handleCommand">
          <span class="el-dropdown-link">
            {{item.lable}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="passwd">修改密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <Passwd v-if="passwdShow" @close='close'></Passwd>
  </div>
</template>

<script>
import Passwd from './passwd'
import config from '@/shared/api/config/api'
export default {
  name: 'navs',

  props: {
    navData: {
      type: Object,
      default () {
        return {
          name: '',
          icon: ''
        }
      }
    }
  },

  components: { Passwd },

  data () {
    return {
      passwdShow: false,
      menuList: [
        {
          id: 1,
          menu: true,
          lable: JSON.parse(sessionStorage.getItem('User')).realName,
          url: 'https://aquilafly-product.oss-cn-shenzhen.aliyuncs.com/B0/adminLayout/User.png'
        },
        {
          id: 2,
          lable: '退出',
          url: 'https://aquilafly-product.oss-cn-shenzhen.aliyuncs.com/B0/adminLayout/Exit.png'
        }
      ]
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {},

    userMenuItemClick (val) {
      if (val !== 2) return
      console.log(sessionStorage.getItem('skip'))
      console.log(config.return)
      if (sessionStorage.getItem('skip')) {
        window.open(`${config.return}/Apps/Home`, '_self')
      } else {
        this.$router.push({ name: 'AUTH' })
        sessionStorage.clear()
      }
    },

    handleCommand (key) {
      switch (key) {
        case 'passwd':
          this.passwdShow = true
          return ''
      }
    },

    close () {
      this.passwdShow = false
    }
  }
}
</script>

<style lang='stylus' scoped>
  .navs
    height 70px
    border-bottom 2px solid #DBE3EF
    display flex
    justify-content center
    align-items center
    position relative
    .title
      color #000000
      font-size 18px
      display flex
      justify-content center
      align-items center
      font-weight bold
      i
        color #409eff
        margin-right 10px
        font-size 24px
    .menu
      position absolute
      right 0
      display flex
      height 70px
      .menuLi
        cursor pointer
        font-size 16px
        color #606266
        display flex
        justify-content center
        align-items center
        margin-right 20px
        img
          width 18px
          margin-right 5px
</style>
